import React from 'react';
import { MessageCircle } from 'lucide-react';
import { useSettings } from '@/context/SettingsContext';

const WhatsAppButton = () => {
  const { settings } = useSettings();
  const whatsappNumber = settings.whatsapp || '902523828700';
  const message = encodeURIComponent('Hello, I would like to get information about Holiday Inn Resort Bodrum West Beach.');
  
  const whatsappUrl = `https://wa.me/${whatsappNumber.replace(/[^0-9]/g, '')}?text=${message}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-button hidden md:flex"
      data-testid="whatsapp-button"
      aria-label="Contact us on WhatsApp"
    >
      <MessageCircle className="w-7 h-7 text-white" />
    </a>
  );
};

export default WhatsAppButton;
